import { IUserAccountStore } from '../index'
import { ILimitWasAccepted } from '../../../actions/userAccount/limit/limitAccepted'

export default function(
  store: IUserAccountStore,
  action: ILimitWasAccepted,
): IUserAccountStore {
  return {
    ...store,
    limits: {
      ...store.limits,
      ...action.limit,
    },
  }
}
